/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginDTO
 */
export interface LoginDTO {
    /**
     * 
     * @type {string}
     * @memberof LoginDTO
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginDTO
     */
    password?: string | null;
}

/**
 * Check if a given object implements the LoginDTO interface.
 */
export function instanceOfLoginDTO(value: object): value is LoginDTO {
    return true;
}

export function LoginDTOFromJSON(json: any): LoginDTO {
    return LoginDTOFromJSONTyped(json, false);
}

export function LoginDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'] == null ? undefined : json['username'],
        'password': json['password'] == null ? undefined : json['password'],
    };
}

  export function LoginDTOToJSON(json: any): LoginDTO {
      return LoginDTOToJSONTyped(json, false);
  }

  export function LoginDTOToJSONTyped(value?: LoginDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'password': value['password'],
    };
}

